module.exports = __webpack_public_path__ + "static/media/ustawienia.bf6e3c3a.svg";